export const stories = {
  musician: [
    <p>
      I just love music! my favorite musician is <b>Hans Zimmer</b>...
    </p>,
    <p>
      In my free time I like to play <b>the guitar</b>...
    </p>,
    <p>
      the music on this website was created by{" "}
      <a href="https://pixabay.com/nl/users/sergequadrado-24990007/">
        SergeQuadrado
      </a>
      .
    </p>,
  ],
  tavern: [
    <p>
      This site rocks thanks to the <b>Three.js</b> library. Big shoutout to{" "}
      <b>Bruno Simon</b> and his awesome{" "}
      <a href="https://threejs-journey.com/">Three.js journey course</a>.
      Cheers, Bruno!🍻
    </p>,
    <p>
      I also made some other <b>websites</b>...
    </p>,
    <p>
      <b>Barbershop Malinov:</b>
      <br />
      <a href="https://barbershopmalinov.com/">
        https://barbershopmalinov.com/
      </a>
      <br />
      <b>Photography Van Hulle:</b>
      <br />
      <a href="https://www.lukasvanhulle.com/">
        https://www.lukasvanhulle.com/
      </a>
    </p>,
    <p>
      I'm currently developing my game development skills. This is the latest{" "}
      <b>game</b> I made...
    </p>,
    <p>
      <b>Valley Invasion:</b>
      <br />
      <a href="https://cachinno.itch.io/valley-invasion">
        https://cachinno.itch.io/valley-invasion
      </a>
    </p>,
    <p>
      Also be sure to check out some of the projects on my <b>Github</b>...
    </p>,
    <p>
      <b>Swift quote generator app:</b>
      <br />
      <a href="https://github.com/ViktorVanHulle/IOSAssignment">
        github.com/ViktorVanHulle/ IOSAssignment
      </a>
      <br />
      <b>C++ Cmake 3D Tetris</b>
      <br />
      <a href="https://github.com/ViktorVanHulle/3D-Tetris">
        github.com/ViktorVanHulle/3D-Tetris
      </a>
    </p>,
    <p>
      <b>Kotlin Food Recognition app</b>
      <br />
      <a href="https://github.com/ViktorVanHulle/Food-Recognition-App">
        github.com/ViktorVanHulle/Food-Recognition-App
      </a>
      <br />
      <b>Spring boot Java website:</b>
      <br />
      <a href="https://github.com/ViktorVanHulle/spring-boot-fifa">
        github.com/ViktorVanHulle/spring-boot-fifa
      </a>
    </p>,
    <p>... and many more!</p>,
    <p>
      If you want to collaborate on a project,{" "}
      <a href="mailto: viktor.van.hulle@gmail.com">let me know</a>!🤝
    </p>,
  ],
  reader: [
    <p>
      I'm currently working on a paper about{" "}
      <b>innovative audio in horror games</b>...
    </p>,
    <p>
      To download my bachelor thesis about{" "}
      <b>educative simulations in the web</b>{" "}
      <a
        href="/images/Bachelorproef_Van_Hulle_Viktor_2023_educatieve_3D_simulaties_TIN.pdf"
        download
      >
        click here
      </a>
      .
    </p>,
  ],
  statue: [
    <p>
      Hi, my name is <b>Viktor Van Hulle</b>...
    </p>,
    <p>
      I'm a 22 year old <b>game-, web- and mobile developer</b> studying for my
      master in game design...
    </p>,
    <p>
      In my free time I like to make <b>websites and games</b>...
    </p>,
    <p>
      For this I use frameworks and programs like <b>React</b>, <b>Three.js</b>,{" "}
      <b>Unity</b>, <b>Blender</b>...
    </p>,
    <p>It's something I can fully immerse myself in...</p>,
    <p>
      Currently I only have had the privilege of building 2 websites for other
      people...
    </p>,
    <p>
      So if you are looking for someone to make you a website that is both{" "}
      <b>creative, immersive and something worthwhile visiting</b>, you can
      always <a href="mailto: viktor.van.hulle@gmail.com">contact me</a>!
    </p>,
  ],
  flag: [
    <p>
      I'm located in <b>Belgium, Ghent</b>...
    </p>,
    <p>
      My native language is <b>Dutch</b> and I am fluent in <b>English</b>. I
      also have basic working knowledge of <b>French</b>.
    </p>,
  ],
  boat: [
    <p>
      I went to <b>Norway on Erasmus</b> during my applied computer science
      studies at HOGENT...
    </p>,
    <p>I met some amazing people from around the globe...</p>,
    <p>
      Participated in some events like <b>the international day</b>...
    </p>,
    <p>
      And took my first <b>game development</b> course!
    </p>,
    <p>
      I also made a <b>video</b> on why you should go on Erasmus...
    </p>,
    <p>
      <a href="https://www.youtube.com/watch?v=pRYSXFinbps">
        Here is a link to that video
      </a>{" "}
      if you want to check it out.
    </p>,
  ],
  route: [
    <p>Here are some links to my personal accounts...</p>,
    <p>
      <b>Twitter</b>:<br />
      <a href="https://twitter.com/cachinnoman">twitter.com/cachinnoman</a>
      <br />
      <b>Github</b>:<br />
      <a href="https://github.com/ViktorVanHulle">github.com/ViktorVanHulle</a>
      <br />
      <b>LinkedIn</b>:<br />
      <a href="https://www.linkedin.com/in/viktorvanhulle/">
        www.linkedin.com/in/viktorvanhulle/
      </a>
      <br />
    </p>,
    <p>and some business related accounts...</p>,
    <p>
      <b>Itch.io</b>:<br />
      <a href="https://cachinno.itch.io/">https://cachinno.itch.io/</a>
      <br />
      <b>Sketchfab</b>:<br />
      <a href="https://sketchfab.com/viktorvanhulle">
        https://sketchfab.com/viktorvanhulle
      </a>
      <br />
      <b>Tiktok</b>:<br />
      <a href="https://www.tiktok.com/@cachinnogames">
        https://www.tiktok.com/@cachinnogames
      </a>
      <br />
    </p>,
  ],
  stage: [
    <p>
      I studied <b>applied computer science</b> for 3 years at the <b>HOGENT</b>
      ...
    </p>,
    <p>
      Here I graduated with honors as a <b>mobile and enterprise developer</b>.
    </p>,
    <p>
      During my bachelor I discovered my <b>passion for design</b>. That is why,
      after completing my degree, I set out to further develop my{" "}
      <b>creative skills</b>...
    </p>,
    <p>
      I started a switch program to my <b>master in Game Design</b> at{" "}
      <b>LUCA School of Arts</b>...
    </p>,
    <p>
      At <b>LUCA</b> I'm gaining knowledge in <b>conceptualizing games</b>,{" "}
      <b>designing levels</b>, <b>analyzing games</b>...
    </p>,
    <p>
      And also sharpening my skills in <b>Unity</b>, <b>Blender</b>,{" "}
      <b>Photoshop</b> and much more!
    </p>,
    <p>
      <a href="https://www.youtube.com/watch?v=MboThV8CM84">Here is a demo</a>{" "}
      of a project I made for an <b>advanced animations</b> course.
    </p>,
  ],

  well: [
    <p>
      My dream is <b>to make games for a living</b>...
    </p>,
    <p>
      That is why I created my studio, <b>Cachinno games</b>...
    </p>,
    <p>
      I'm currently developing my first commercial game in <b>Unity</b>...
    </p>,
    <p>Wishlist link coming soon!✨</p>,
  ],
};
